import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Config} from './config';

@Injectable({
              providedIn: 'root'
            })
export class ConfigService {
  config: Config | undefined;

  constructor(private http: HttpClient) {
  }

  loadConfig(): Promise<void> {
    return this.http.get<Config>(`/config/${environment.configFile}`)
               .toPromise()
               .then((config: any) => this.config = config,
                     (err: any) => console.error(err.message));
  }

}
